// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import '../node_modules/vuetify/src/stylus/app.styl'
import 'vuetify/dist/vuetify.min.css'
import Toasted from 'vue-toasted';
import axios from 'axios'
import moment from 'moment'
import $ from 'jquery'
// import ZkTable from 'vue-table-with-tree-grid'
// import TreeDataTable from 'v-tree-data-table';
// Vue.component('v-tree-data-table', TreeDataTable);
// import VueAdsTableTree from 'vue-ads-table-tree';
// import '../node_modules/@fortawesome/fontawesome-free/css/all.css';
// import '../node_modules/vue-ads-table-tree/dist/vue-ads-table-tree.css';
// Vue.use(VueAdsTableTree)
// Vue.use(ZkTable)
// Vue.use(TreeDataTable)
window.axios = axios;
window.moment = moment;
window.$ = $
Vue.use(Toasted);
Vue.use(Vuetify);
Vue.config.productionTip = false;
Vue.prototype.$myClubFlag = false;
Vue.prototype.$kbCategories = [];
/*String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}*/


if (process.env.NODE_ENV === 'production') {
    console.log = function () {
    };
    console.warn = function () {
    };
    console.error = function () {
    };
}
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js